// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2LD3V","productName":"Table_productName__2Yf3Z"};